import * as S from '../../../../schema';
import { get, post } from '../../shared/MessageBaseAxiosApi';
import { AliyunSlsApmTrackerUtils } from '../../../vendor-apis/aliyun-apm';

/** 查询订单消息 */
export const queryOrderMessages = async (params: S.OrderMessageListParams) => {
  return get(`/v1/orders/${params.orderId}/messages`, params);
};

/** 查询当前用户收到的订单新消息(每个订单只返回最后一条) */
export const queryOrderNewMessage = async () => {
  return get('/v1/order/message/new');
};

/** 发送订单消息 */
export const sendOrderMessage = async (params: S.MessagePayload) => {
  return AliyunSlsApmTrackerUtils.getAliyunSlsApmTracker().runAndSendApiRecord(
    {
      api_id: 'post-/v1/orders/:orderId/messages',
      // TODO: 需要修改为实际的请求地址
      request_url: `${window.gConfig.MESSAGE_ENDPOINT}/v1/orders/${params.orderId}/messages`,
      request_params: JSON.stringify(params),
    },
    async () => {
      return post(`/v1/orders/${params.orderId}/messages`, params);
    },
  );
};

/** 消息已读处理 */
export const readOrderMessage = async (messageIds: string[]) => {
  return post('/v1/order/message/read', messageIds);
};
/** 消息已读处理 */
export const readOrderMessageByOrderId = async (orderId: string) => {
  return post(`/v1/orders/${orderId}/messages/read`);
};

/** 查询订单新消息数量 */
export const queryOrderNewMessageCount = async (orderIds: string[]) => {
  return post(`/v1/order/message/count`, orderIds);
};
